import client from '../../../enrollment-platform/api/eps.client'
import { AxiosResponse } from 'axios'

/**
 * Uploads a CSV file for payment bulk transactions
 */
export async function uploadPaymentBulkCsv(file: File): Promise<void> {
  const formData = new FormData()
  formData.append('file', file)

  const response: AxiosResponse<void> = await client.post(
    '/api/v1/payment-bulk-transactions/upload-file',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )

  return response.data
}
